import {
  Box,
  // Flex,
  HStack,
  // Image,
  // Img,
  Text,
  Link,
  useBreakpointValue,
} from "@chakra-ui/react";
import React from "react";
// import BlogSub2Image1 from "../../../../assets/images/blogDetails/Ellipse 1.png";
// import BlogSub2Image2 from "../../../../assets/images/blogDetails/Group 3834.png";
const BlogDetailsSub2 = () => {
  const isXLScreen = useBreakpointValue({ base: false, xl: true });

  return (
    <Box className={isXLScreen ? "container" : "container-responsive"}>
      <Box paddingTop="60px" paddingBottom="60px">
        <HStack
          gap="20px"
          flexDirection={{ base: "column", xl: "row" }}
          alignItems="center"
        >
          <Text
            color="#333"
            fontSize="24px"
            fontStyle="normal"
            fontWeight="500"
            lineHeight="36px"
          >
            Share
          </Text>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="41"
            height="2"
            viewBox="0 0 41 2"
            fill="none"
          >
            <path
              d="M1 0.5C0.723858 0.5 0.5 0.723858 0.5 1C0.5 1.27614 0.723858 1.5 1 1.5L1 0.5ZM1 1.5L41 1.5L41 0.499997L1 0.5L1 1.5Z"
              fill="#333333"
            />
          </svg>
          <Box>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="183"
              height="16"
              viewBox="0 0 183 16"
              fill="none"
            >
              <path
                d="M17 2.66066C16.3748 2.94128 15.7033 3.1309 14.9972 3.2166C15.7257 2.77503 16.2707 2.08003 16.5306 1.2613C15.8461 1.67314 15.0971 1.96302 14.3159 2.11836C13.7906 1.55017 13.0948 1.17357 12.3366 1.04702C11.5784 0.920468 10.8001 1.05105 10.1226 1.41849C9.44514 1.78594 8.90638 2.36968 8.58996 3.0791C8.27354 3.78852 8.19718 4.58391 8.37272 5.3418C6.98589 5.27126 5.6292 4.90611 4.3907 4.27003C3.1522 3.63395 2.05956 2.74117 1.1837 1.64963C0.884216 2.17297 0.712014 2.77973 0.712014 3.42594C0.71168 4.00767 0.853094 4.58049 1.12371 5.09358C1.39432 5.60667 1.78577 6.04416 2.26332 6.36724C1.70949 6.34938 1.16788 6.19778 0.683564 5.92506V5.97056C0.683508 6.78647 0.962105 7.57726 1.47208 8.20877C1.98206 8.84027 2.69201 9.27359 3.48146 9.43519C2.96769 9.57605 2.42904 9.5968 1.90619 9.49587C2.12893 10.1979 2.5628 10.8118 3.14706 11.2516C3.73133 11.6915 4.43674 11.9352 5.16454 11.9487C3.92906 12.9312 2.40325 13.4642 0.832555 13.4618C0.554324 13.4619 0.276328 13.4455 0 13.4125C1.59434 14.451 3.45027 15.0021 5.34572 15C11.7621 15 15.2698 9.61647 15.2698 4.9474C15.2698 4.79571 15.266 4.6425 15.2593 4.49081C15.9416 3.99097 16.5305 3.37201 16.9985 2.66293L17 2.66066Z"
                fill="#FD8534"
              />
              <path
                d="M64.5 3H67V0H64.5C62.57 0 61 1.57 61 3.5V5H59V8H61V16H64V8H66.5L67 5H64V3.5C64 3.229 64.229 3 64.5 3Z"
                fill="#FD8534"
              />
              <path
                d="M124.948 4.72248C124.94 4.05067 124.814 3.38554 124.576 2.75685C124.37 2.22655 124.056 1.74494 123.653 1.34279C123.25 0.940648 122.768 0.626811 122.237 0.421333C121.615 0.188364 120.958 0.0623939 120.295 0.048786C119.44 0.0106443 119.169 0 116.999 0C114.829 0 114.551 5.94791e-08 113.703 0.048786C113.039 0.0624939 112.383 0.188463 111.761 0.421333C111.23 0.626668 110.748 0.940454 110.345 1.34262C109.942 1.74478 109.628 2.22646 109.422 2.75685C109.188 3.37699 109.062 4.03247 109.05 4.69498C109.012 5.54917 109 5.81972 109 7.98581C109 10.1519 109 10.4287 109.05 11.2766C109.063 11.9401 109.188 12.5947 109.422 13.2165C109.628 13.7468 109.943 14.2283 110.346 14.6302C110.749 15.0322 111.231 15.3459 111.762 15.5512C112.382 15.7935 113.039 15.9285 113.704 15.9503C114.559 15.9885 114.83 16 117 16C119.17 16 119.448 16 120.296 15.9503C120.96 15.9373 121.617 15.8116 122.239 15.5787C122.77 15.373 123.252 15.059 123.655 14.6569C124.057 14.2548 124.372 13.7733 124.578 13.2432C124.812 12.6222 124.937 11.9676 124.95 11.3033C124.988 10.4499 125 10.1794 125 8.01242C124.998 5.84633 124.998 5.57135 124.948 4.72248ZM116.994 12.0821C114.725 12.0821 112.886 10.2468 112.886 7.98137C112.886 5.71593 114.725 3.8807 116.994 3.8807C118.083 3.8807 119.128 4.31273 119.898 5.08176C120.669 5.85078 121.101 6.89381 121.101 7.98137C121.101 9.06894 120.669 10.112 119.898 10.881C119.128 11.65 118.083 12.0821 116.994 12.0821ZM121.265 4.68522C121.139 4.68534 121.014 4.66068 120.898 4.61267C120.782 4.56466 120.676 4.49423 120.587 4.40542C120.498 4.3166 120.428 4.21114 120.38 4.09508C120.332 3.97901 120.307 3.85462 120.307 3.72902C120.307 3.6035 120.332 3.47922 120.38 3.36326C120.428 3.24731 120.498 3.14194 120.587 3.05319C120.676 2.96444 120.782 2.89404 120.898 2.84601C121.014 2.79798 121.139 2.77326 121.264 2.77326C121.39 2.77326 121.515 2.79798 121.631 2.84601C121.747 2.89404 121.852 2.96444 121.941 3.05319C122.03 3.14194 122.101 3.24731 122.149 3.36326C122.197 3.47922 122.222 3.6035 122.222 3.72902C122.222 4.25768 121.793 4.68522 121.265 4.68522Z"
                fill="#FD8534"
              />
              <path
                d="M117 11C118.657 11 120 9.65685 120 8C120 6.34315 118.657 5 117 5C115.343 5 114 6.34315 114 8C114 9.65685 115.343 11 117 11Z"
                fill="#FD8534"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M172.943 5.5752H175.914V7.0552C176.342 6.204 177.44 5.4392 179.089 5.4392C182.25 5.4392 183 7.1336 183 10.2424V16H179.8V10.9504C179.8 9.18 179.372 8.1816 178.282 8.1816C176.771 8.1816 176.143 9.2576 176.143 10.9496V16H172.943V5.5752ZM167.456 15.864H170.656V5.4392H167.456V15.864ZM171.114 2.04C171.115 2.30822 171.061 2.57379 170.958 2.82127C170.854 3.06875 170.703 3.29321 170.512 3.4816C170.125 3.8661 169.601 4.08132 169.056 4.08C168.512 4.07963 167.989 3.86496 167.602 3.4824C167.411 3.29337 167.26 3.06866 167.157 2.82115C167.054 2.57363 167 2.30818 167 2.04C167 1.4984 167.216 0.98 167.602 0.5976C167.99 0.214527 168.512 -0.000239369 169.057 2.00212e-07C169.602 2.00212e-07 170.126 0.2152 170.512 0.5976C170.898 0.98 171.114 1.4984 171.114 2.04Z"
                fill="#FD8534"
              />
            </svg>
          </Box>
        </HStack>
        <HStack
          paddingY="110px"
          flexDirection={{ base: "column", xl: "row" }}
          justifyContent="space-between"
        >
          <Box width={{ base: "100%", xl: "13%" }}>
            <Link href="/blog-details-sub2">
              <Text
                textAlign="right"
                color="#999"
                fontSize="18px"
                fontStyle="normal"
                fontWeight="500"
                lineHeight="normal"
              >
                PREVIOUS POST
              </Text>
            </Link>
            <Text
              paddingTop="7px"
              textAlign="end"
              color="#333"
              fontSize="20px"
              fontStyle="normal"
              fontWeight="700"
              lineHeight="36px"
            >
              How Smart...
            </Text>
          </Box>
          <Box
            width={{ base: "100%", xl: "18%" }}
            paddingTop={{ base: "30px", xl: "0px" }}
          >
            <Link href="/blog-details-sub4">
              <Text
                textAlign="start"
                color="#999"
                fontSize="18px"
                fontStyle="normal"
                fontWeight="500"
                lineHeight="normal"
              >
                NEXT POST
              </Text>
            </Link>
            <Text
              paddingTop="7px"
              textAlign="start"
              color="#333"
              fontSize="20px"
              fontStyle="normal"
              fontWeight="700"
              lineHeight="36px"
            >
              Beyond Traditional...
            </Text>
          </Box>
        </HStack>
        {/* <HStack
          flexDirection={{ base: "column", xl: "row" }}
          border="1px dashed #ccc"
          alignItems="center"
          justifyContent={{ base: "center", xl: "start" }}
          borderRadius="5px"
          paddingY="40px"
          paddingX={{ base: "20px", xl: "60px" }}
        >
          <Flex
            justifyContent={{ base: "center", xl: "start" }}
            width={{ base: "100%", xl: "20%" }}
          >
            <Image width="fit-content" src={BlogSub2Image1} />
          </Flex>
          <Box width={{ base: "100%", xl: "80%" }}>
            <Text
              paddingY={{ base: "20px", xl: "0px" }}
              color="#333"
              fontSize={{ base: "20px", xl: "30px" }}
              fontStyle="normal"
              fontWeight="700"
              lineHeight="36px"
            >
              Rachel Green
            </Text>
            <Text
              paddingBottom="10px"
              color="#666"
              fontSize={{ base: "14px", xl: "20px" }}
              fontStyle="normal"
              fontWeight="500"
              lineHeight="31px"
            >
              A passionate writer and real estate enthusiast sharing insights on
              property investment, financial freedom, and wealth creation
              through her blog.
            </Text>
            <Box paddingY="20px">
              <Img src={BlogSub2Image2} />
            </Box>
          </Box>
        </HStack> */}
      </Box>
    </Box>
  );
};

export default BlogDetailsSub2;
